import ScienceOutlined from "@mui/icons-material/ScienceOutlined";

import { makeSvgIcon } from "./svg-icon";

export const ScienceIcon = makeSvgIcon(ScienceOutlined);

export default ScienceIcon;
